'use strict';

module.exports = {
    FLOW_NEW_CARD_NAME: 'newcard',
    FLOW__SESSION_CARD_NAME: 'sessioncard',
    FLOW_JS_STORED_CARD_NAME: 'js_stored_card'
};
